import { useCallback } from 'react';
import { StyleSheet } from 'react-native';
import { Typography, Flex, List } from '@banhala/ui-kit';
import type { HorizontalChipListProps, HorizontalChipItem } from './types';
import type { AnyObject } from '../../../../types';
import { bridge, isNil } from '../../../../utils';

type ChipEntity = { item: HorizontalChipItem; logging: AnyObject };

const keyExtractor = (_item: ChipEntity, index: number) => index.toString();

export const HorizontalChipList = ({ entity }: HorizontalChipListProps) => {
  const handleChipPress = useCallback(
    (deeplink: string, name: string, logging: AnyObject) => {
      if (deeplink) {
        bridge.logAnalyticsEvent({
          name: 'CLICK_HORIZONTAL_CHIP_LIST',
          analytics: { ...logging.analytics, NAME: name },
          ably_only_log: logging.ably_only_log,
        });
        bridge.openDeeplink(deeplink);
      }
    },
    [],
  );

  const renderItem = useCallback(
    ({ item: chipData }: { item: ChipEntity }) => {
      const { name, deeplink } = chipData.item;
      return (
        <Flex
          alignSelf="flex-start"
          borderWidth={1}
          borderColor="gray30"
          borderRadius={100}
          backgroundColor="bg_always_white"
          padding={{ horizontal: 12, vertical: 9 }}
          onPress={() => handleChipPress(deeplink, name, chipData.logging)}
        >
          <Typography type="subtitle3" color="content_secondary">
            {name}
          </Typography>
        </Flex>
      );
    },
    [handleChipPress],
  );

  if (isNil(entity) || entity.length === 0) {
    return null;
  }

  return (
    <List
      horizontal
      data={entity}
      renderItem={renderItem}
      keyExtractor={keyExtractor}
      showsHorizontalScrollIndicator={false}
      contentContainerStyle={styles.scrollContent}
    />
  );
};

const styles = StyleSheet.create({
  scrollContent: {
    paddingHorizontal: 16,
    gap: 8,
  },
});
